//src/components/services/ServicePackages.js
import React from 'react';
import ServiceCard from './ServiceCard';

// Import sample images - replace these with your actual images
import washingImage from '../images/handwash.jpg';
import vaccuum from '../images/vaccuum.jpg';
import buffing from '../images/exteriorDetail.jpg';
import interiorImage from '../images/interiorDetail.jpg';
import deepCleanImage from '../images/interiorDetail.jpg';
import fulldetail from '../images/FullDetail.jpg';
import classicwash from '../images/main.jpg';
import polish from '../images/polish.png';
import shampoo from '../images/shampoo.jpg';

// If you don't have the actual images yet, you can use these as placeholders
const placeholderImages = {
  washing: "https://placehold.co/600x400/gray/white?text=Washing",
  polishRed: "https://placehold.co/600x400/red/white?text=Polish",
  polishBlue: "https://placehold.co/600x400/blue/white?text=Polish", 
  interior: "https://placehold.co/600x400/brown/white?text=Interior",
  deepClean: "https://placehold.co/600x400/black/white?text=Deep+Clean"
};

// Service data
const servicesData = {
  // Full Detail Packages
  full: [
    {
      id: 'silver',
      title: 'Silver Full Detail',
      tagline: 'Refresh',
      taglineColor: 'orange-400', 
      image: washingImage,
      fallbackImage: placeholderImages.washing,
      description: 'Our Refresh Package. Best for maintenance or quick refresh.',
      price: 195,
      features: {
        'INTERIOR': [
          'Interior Vacuum',
          'Wipe all surfaces',
          'Stains (Spot Treatment)',
          'Windows & Mirrors',
          'Door Jambs',
          'Floor Mats',
          'Detail Trunk'
        ],
        'EXTERIOR': [
          'Quick Hand Wash',
          'Clean Rims & Tires',
          'Wax Protection (3 Months)'
        ]
      }
    },
    {
      id: 'gold',
      title: 'Gold Full Detail',
      tagline: 'Most Popular',
      taglineColor: 'orange-400',
      image: vaccuum,
      fallbackImage: placeholderImages.interior,
      description: 'Our Standard Package. A very thorough inside-out detail.',
      price: 275,
      features: {
        'INTERIOR': [
          'Double Vacuum Interior',
          'Wipe all surfaces',
          'Stains (Spot Treatment)',
          'Windows & Mirrors',
          'Clean & Protect Plastic',
          'Detail Floor Mats and Shine',
          'Detail Trunk & Door Jambs'
        ],
        'EXTERIOR': [
          'Spot Polish',
          'Professional Hand Wash',
          'Clay Bar Exterior',
          'Detail Rims & Tires',
          'Wheel Wells',
          'Wax Protection (3 Months)'
        ]
      }
    },
    {
      id: 'diamond',
      title: 'Diamond Full Detail',
      tagline: 'VIP',
      taglineColor: 'yellow-400',
      image: fulldetail,
      fallbackImage: placeholderImages.polishBlue,
      description: 'Ultimate Detail Experience. Includes Full Polish & Shampoo/Extraction.',
      price: 399,
      features: {
        'INTERIOR': [
          'Shampoo Seats & Carpet',
          'Double Vacuum Interior',
          'Wipe all Surfaces',
          'Stain (Spot Treatment)',
          'Clean & Protect Plastic',
          'Windows & Mirrors',
          'Detail Floor Mats and Shine',
          'Detail Trunk'
        ],
        'EXTERIOR': [
          'Premium 1-Step Polish',
          'Professional Hand Wash',
          'Clay Bar Exterior',
          'Wash Wheel Wells',
          'Dress Trims/Tires',
          'Clean Door Jams',
          'Wax Protection (3 Months)'
        ]
      }
    }
  ],
  
  // Exterior Only Packages
  exterior: [
    {
      id: 'classic_exterior',
      title: 'Classic Exterior',
      tagline: 'Classic',
      taglineColor: 'orange-400',
      image: classicwash,
      fallbackImage: placeholderImages.washing,
      description: 'Our Classic Package. Best for maintenance or quick refresh.',
      price: 168,
      features: [
        'Basic Spot Polish',
        'Professional Hand Wash',
        'Clay Bar Exterior',
        'Wheel Wells',
        'Detail Rim & Tires',
        'Window & Mirrors',
        'Wax Protection (3 Months)'
      ]
    },
    {
      id: 'wax_polish',
      title: 'Wax & Polish',
      tagline: 'Popular',
      taglineColor: 'orange-400',
      image: buffing,
      fallbackImage: placeholderImages.polishRed,
      description: 'This Package will remove light swirls and scratches.',
      price: 289,
      features: [
        '1-Step Paint Correction Polish',
        'Professional Hand Wash',
        'Clay Bar Exterior',
        'Wheel Wells',
        'Detail Rim & Tires',
        'Window & Mirrors',
        'Wax Protection (3 Months)'
      ]
    },
    {
      id: 'cut_polish',
      title: 'Cut & Polish',
      tagline: 'VIP',
      taglineColor: 'yellow-400',
      image: polish,
      fallbackImage: placeholderImages.polishBlue,
      description: 'This Package will remove deep swirls and scratches.',
      price: 439,
      features: [
        '2-Step Paint Correction Polish',
        'Professional Hand Wash',
        'Clay Bar Exterior',
        'Wheel Wells',
        'Detail Rim & Tires',
        'Window & Mirrors',
        'Wax Protection (3 Months)'
      ]
    }
  ],
  
  // Interior Only Packages
  interior: [
    {
      id: 'classic_interior',
      title: 'Classic Interior',
      tagline: 'Classic',
      taglineColor: 'orange-400',
      image: interiorImage,
      fallbackImage: placeholderImages.interior,
      description: 'Good for maintaining your vehicle interior.',
      price: 186,
      features: [
        'Complete Interior Vacuum',
        'Wipe All Surface',
        'Stains (Spots Treatment)',
        'Windows & Mirrors',
        'Detail Floor Mats and Shine',
        'Detail Trunk'
      ]
    },
    {
      id: 'comfort_interior',
      title: 'Comfort Interior',
      tagline: 'Most Popular',
      taglineColor: 'orange-400',
      image: vaccuum,
      fallbackImage: placeholderImages.interior,
      description: 'Enhanced interior cleaning with extra attention to detail.',
      price: 239,
      features: [
        'Double Interior Vacuum',
        'Complete Surface Cleaning',
        'Stain Treatment & Spot Cleaning',
        'Clean & Protect Plastic Surfaces',
        'Windows & Mirrors Polishing',
        'Deep Clean Door Panels & Jambs',
        'Detail Floor Mats and Apply Protectant',
        'Complete Trunk Detailing'
      ]
    },
    {
      id: 'deep_clean',
      title: 'Deep Clean',
      tagline: 'Premium',
      taglineColor: 'yellow-400',
      image: shampoo,
      fallbackImage: placeholderImages.deepClean,
      description: 'Includes seat & carpet shampoo and conditioner.',
      price: 289,
      features: [
        'Deep Cleaning Treatment',
        'Shampoo All Carpets & Seats',
        'Double Vacuum Interior',
        'Stain Extraction',
        'Clean & Protect All Plastic',
        'Windows & Mirrors',
        'Detail Floor Mats and Shine',
        'Detail Trunk'
      ]
    }
  ]
};

// Fallback function for images - use this until you have the actual images
const getImage = (imagePath, fallbackUrl) => {
  try {
    return imagePath;
  } catch (error) {
    return fallbackUrl;
  }
};

const ServicePackages = ({ activeTab,  }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
      {servicesData[activeTab].map(service => (
        <ServiceCard
          key={service.id}
          category={activeTab}
          serviceId={service.id}
          title={service.title}
          tagline={service.tagline}
          taglineColor={service.taglineColor}
          image={service.image}
          fallbackImage={service.fallbackImage}
          description={service.description}
          price={service.price}
          features={service.features}
          getImage={getImage}
        />
      ))}
    </div>
  );
};

export default ServicePackages;